<script>

import Lang from "../../lang/lang";

export default {
  name: "FarmInfo",
  props: ['farm'],
  data: function () {
    return {
      devicesOpened: false,
      formatRate: window['formatRate'],
      formatBigDollar: window['formatBigDollar'],
    }
  },
  computed: {
    images() {
      return [
          '/assets/images/offer-devices/antminer-s19.png'
      ];
    },
    lang() {
      return Lang.texts('farmInfo');
    },
    description() {
      let descText = this.lang['desc'];
      descText = descText.replace('%miniFarmTitle%', this.farm.title);

      let devices = [];
      for (let device of this.farm.devices) {
        let text = this.lang['deviceDesc'];
        text = text.replace('%count%', device.workerCount);
        text = text.replace('%model%', device.model);
        text = text.replace('%rate%', this.formatRate(device.workerRate));
        devices.push(text);
      }

      descText = descText.replace('%devices%', devices.join(", "));
      return descText;
    },
    description2() {
      return this.lang['desc2'].replace('%miniFarmTitle%', this.farm.title);
    },
    description3() {
      if (this.farm.serviceFee === 0) return '';
      return this.lang['desc3'].replace('%miniFarmServiceFee%', this.farm.serviceFee * 100 + '%');
    }
  }
}
</script>

<template>
  <div class="farm-block">
    <div class="farm-left no-right">
      <div class="farm-photo"
           style="--image: url('/assets/images/offer-devices/antminer-s19.png')"></div>
      <div :class="'farm-info accordion' + (devicesOpened ? ' opened' : '')">
        <div class="accordion-switch" @click="devicesOpened = !devicesOpened">
          {{ lang['deviceDetails'] }}
        </div>
        <div class="accordion-data">
          <div class="grid" v-for="device of farm.devices">
            <div class="item-section">Device details:</div>
            <div class="item-title">
              {{ lang['model'] }}:
            </div>
            <div class="item-value gold">
              {{ device.model }}
            </div>
            <div class="item-title">
              Quantity:
            </div>
            <div class="item-value">
              {{ device.workerCount }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="farm-right">
      <h1>{{ farm.title }}</h1>
      <div class="farm-desc">
        {{ description }}
        <br/><br/>
        <!--{{ description2 }}
        {{ description3 }}-->
      </div>
      <div class="farm-details-container">
        <div class="farm-details">
          <div class="farm-details-title">
            {{ lang['groupMiningDetails'] }}
          </div>
          <div class="item-title">
            {{ lang['totalHashrate'] }}:
          </div>
          <div class="item-value">
            {{ formatRate(farm.totalRate, 1) }}
          </div>
          <div class="item-title">
            {{ lang['totalValue'] }}:
          </div>
          <div class="item-value">
            {{ formatBigDollar(farm.totalValue) }}
          </div>
          <div class="item-title">
            {{ lang['devices'] }}:
          </div>
          <div class="item-value">
            {{ farm.totalDevices }}
          </div>
        </div>
        <div class="farm-details">
          <div class="farm-details-title">
            {{ lang['hostingDetails'] }}
          </div>
          <div class="item-title">
            {{ lang['electricityFee'] }}:
          </div>
          <div class="item-value">
            {{ farm.hostingFee }} {{ lang['kwh'] }}
          </div>
          <div class="item-title">
            {{ lang['securityDeposit'] }}:
          </div>
          <div class="item-value">
            {{ farm.depositDays }} {{ lang['days'] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>